import { render, staticRenderFns } from "./HandleItemBrandTabGeneral.vue?vue&type=template&id=f7d58354"
import script from "./HandleItemBrandTabGeneral.vue?vue&type=script&lang=js"
export * from "./HandleItemBrandTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./HandleItemBrandTabGeneral.vue?vue&type=style&index=0&id=f7d58354&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports